const shared = {
  fr: {
    backSite: 'Retour au site',
    logout: 'Déconnexion',
    welcome: 'Bonjour',
    overview: 'Vue d’ensemble',
    profile: 'Profil',
    save: 'Enregistrer',
    saved: 'Profil mis à jour',
    refresh: 'Actualiser',
    quickActions: 'Actions rapides',
    navMessages: 'Messages',
    edit: 'Modifier le profil',
    back: 'Retour',
    empty: 'Aucun élément pour le moment.',
    actions: 'Actions',
    assign: 'Assigner',
    assignTo: 'Assigner à',
    changeStatus: 'Changer le statut',
    view: 'Voir',
    upload: 'Déposer un fichier',
    startMission: 'Démarrer',
    markReady: 'Marquer prêt',
    markDelivered: 'Marquer livré',
    addTranslator: 'Ajouter un traducteur',
    editProfile: 'Modifier le profil',
    availAvailable: 'Disponible',
    availBusy: 'Occupé',
    availUnavailable: 'Indisponible',
    specialties: 'Spécialités',
    langPairs: 'Paires de langues',
    experience: 'Années d’expérience',
    sworn: 'Assermenté',
    bio: 'Bio',
    pageRate: 'Tarif / page',
    availability: 'Disponibilité',
    timeline: 'Suivi',
    deliverables: 'Livrables',
    orderDetail: 'Détail commande',
    missionDetail: 'Détail mission',
    noTranslator: 'Aucun traducteur',
    selectTranslator: 'Choisir un traducteur',
    confirmAssign: 'Confirmer l’assignation',
    fromLang: 'De',
    toLang: 'Vers',
    addPair: 'Ajouter une paire',
    assignHowTitle: 'Comment une commande est affectée',
    assignHowText: 'L’admin ouvre la commande, choisit un traducteur dont les paires De→Vers correspondent, puis confirme. Une mission est créée automatiquement.',
    matchLangs: 'Traducteurs compatibles avec',
    noMatch: 'Aucun traducteur actif pour cette paire. Affichage de tous les traducteurs actifs.',
    clientInfoTitle: 'Vos infos utiles',
    clientInfoOrders: 'Suivez chaque commande : pending → assigned → en cours → prêt → livré.',
    clientInfoFiles: 'Quand le statut est « Prêt » ou « Livré », téléchargez vos documents traduits ici.',
    translatorInfoTitle: 'Votre activité',
    translatorInfoPairs: 'Déclarez précisément vos paires : langue source (De) → langue cible (Vers).',
    translatorInfoMissions: 'Une mission apparaît ici seulement après assignation admin.',
    howItWorks: 'Comment ça marche',
    matchScore: 'Score de compatibilité',
    payment: {
      unpaid: 'Non payé',
      pending: 'Paiement en cours',
      paid: 'Payé',
      refunded: 'Remboursé',
      failed: 'Échoué',
    },
    priority: {
      normal: 'Normale',
      high: 'Haute',
      urgent: 'Urgente',
    },
    status: {
      pending: 'En attente',
      in_progress: 'En cours',
      ready: 'Prêt',
      delivered: 'Livré',
      assigned: 'Assigné',
      answered: 'Répondu',
      sent: 'Envoyé',
      accepted: 'Accepté',
      rejected: 'Refusé',
      refused: 'Refusé',
      issued: 'Émise',
      paid: 'Payée',
      draft: 'Brouillon',
      active: 'Actif',
      busy: 'Occupé',
      unavailable: 'Indisponible',
      cancelled: 'Annulé',
      toAssign: 'En attente d’affectation',
      completed: 'Terminée',
      request_sent: 'Demande envoyée',
      pending_review: 'En cours d’examen',
      quote_sent: 'Devis envoyé',
      quote_accepted: 'Devis accepté',
      quote_expired: 'Devis expiré',
      payment_pending: 'En attente de paiement',
      payment_failed: 'Paiement échoué',
      translator_to_assign: 'En attente d’affectation',
      translator_unavailable: 'Professionnel indisponible',
      translator_assigned: 'Professionnel affecté',
      translation_in_progress: 'Traduction en cours',
      translation_submitted: 'Traduction soumise',
      verification_requested: 'Vérification demandée',
      lawyer_notary_in_progress: 'Vérification en cours',
      new_version: 'Nouvelle version',
      verification_validated: 'Vérification validée',
      final_control: 'Contrôle final',
      ready_to_deliver: 'Prête à livrer',
      correction_requested: 'Correction demandée',
      validated: 'Validé',
    },
    accept: 'Accepter',
    reject: 'Refuser',
    send: 'Envoyer',
    cancel: 'Annuler',
    demoHint: 'Comptes démo',
    roleClient: 'Client',
    roleTranslator: 'Traducteur',
    roleAdmin: 'Admin',
    roleLegal: 'Vérificateur',
    client: {
      title: 'Client',
      navHome: 'Tableau de bord',
      navOrders: 'Mes commandes',
      navQuotes: 'Mes devis',
      navInvoices: 'Factures',
      navMessages: 'Messages',
      navProfile: 'Mon profil',
      homeTitle: 'Votre espace Tarjemlek',
      homeSubtitle: 'Suivez vos commandes, devis et documents certifiés.',
      statOrders: 'Commandes',
      statQuotes: 'Devis',
      statReady: 'Documents prêts',
      statDone: 'Terminées',
      colPro: 'Professionnel',
      ctaOrder: 'Nouvelle commande',
      ctaQuote: 'Demander un devis',
      ctaOrders: 'Voir mes commandes',
      ctaDocs: 'Mes documents',
      ctaPayments: 'Mes paiements',
      ctaMessages: 'Messages',
      recentOrders: 'Commandes récentes',
      ordersTitle: 'Mes commandes',
      ordersSubtitle: 'Historique et statut de vos traductions.',
      colId: 'N°',
      colDocument: 'Document',
      colLangs: 'Langues',
      colStatus: 'Statut',
      colPrice: 'Prix',
      colDate: 'Date',
      quotesTitle: 'Mes devis',
      quotesSubtitle: 'Demandes de devis en cours et répondus.',
      colType: 'Type',
      acceptQuote: 'Accepter',
      rejectQuote: 'Refuser',
      invoicesTitle: 'Mes factures',
      invoicesSubtitle: 'Factures émises pour vos commandes.',
      messagesTitle: 'Messagerie',
      messagesSubtitle: 'Échangez avec l’équipe Tarjemlek.',
      messageLabel: 'Votre message',
      sendMessage: 'Envoyer',
      recipient: 'Destinataire',
      administration: 'Administration',
      profileTitle: 'Mon profil',
      profileSubtitle: 'Mettez à jour vos informations de contact.',
      fieldName: 'Nom complet',
      fieldEmail: 'Email',
      fieldPhone: 'Téléphone',
      fieldCity: 'Ville',
      detailTitle: 'Détail de la commande',
      detailSubtitle: 'Suivi et livrables de votre traduction.',
      backOrders: 'Retour aux commandes',
      statProgress: 'En traitement',
      searchOrders: 'Rechercher une commande…',
      filterAll: 'Toutes',
      filterService: 'Prestation',
      catTranslation: 'Traduction',
      catInterpreting: 'Interprétariat',
      viewOrder: 'Voir la commande',
      orderedOn: 'Commandée le',
      awaitingTitle: 'En attente d’affectation',
      awaitingText: 'Nous recherchons un professionnel compatible avec votre demande.',
      proLabel: 'Professionnel',
      secSummary: 'Résumé',
      secProgress: 'Progression',
      secDocs: 'Documents',
      secDocsSent: 'Documents envoyés',
      secDocsFinal: 'Documents finaux disponibles',
      download: 'Télécharger',
      secPro: 'Professionnel',
      contactPro: 'Contacter le professionnel',
      secPayment: 'Paiement',
      payAmount: 'Montant',
      payMethod: 'Méthode',
      payDate: 'Date',
      payRef: 'Référence',
      payAwaitingPro: 'Paiement disponible dès qu’un professionnel aura accepté votre commande.',
      viewPayments: 'Voir mes paiements',
      secDelivery: 'Livraison',
      deliveryMode: 'Mode de livraison',
      deliveryAddress: 'Adresse',
      deliveryPlanned: 'Date prévue',
      deliveryTracking: 'N° de suivi',
      secMessages: 'Messages',
      messagesHint: 'Conversation liée à cette commande : vous, le professionnel affecté et l’administration.',
      goMessages: 'Ouvrir la messagerie',
      secHistory: 'Historique',
      stepCreated: 'Commande créée',
      stepPaid: 'Paiement',
      stepAssigned: 'Professionnel affecté',
      stepProgress: 'Traduction en cours',
      stepVerify: 'Vérification',
      stepDelivery: 'Livraison',
      stepDone: 'Terminée',
      documentsTitle: 'Mes documents',
      documentsSubtitle: 'Retrouvez les documents envoyés et les documents finaux de vos commandes.',
      searchDocs: 'Rechercher un document…',
      colDoc: 'Document',
      colOrder: 'Commande',
      docType: 'Type',
      docSent: 'Document envoyé',
      docInProgress: 'Document en cours',
      docTranslated: 'Document traduit',
      docFinal: 'Document final',
      docAvailable: 'Disponible',
      filtersTitle: 'Filtres',
      resetFilters: 'Réinitialiser',
      searchLabel: 'Recherche',
      payLabel: 'Paiement',
      sortLabel: 'Tri',
      sortRecent: 'Plus récentes',
      sortOldest: 'Plus anciennes',
      sortDeadline: 'Échéance proche',
      sortAmount: 'Montant (décroissant)',
      fromLabel: 'Du',
      toLabel: 'Au',
      overdueLabel: 'En retard',
      kpiAll: 'Total compte',
      kpiProgress: 'En attente ou en cours',
      kpiReady: 'Prêts / livrés',
      kpiQuotes: 'Demandes ouvertes',
      statTotalPaid: 'Total payé',
      statPendingPayments: 'Paiements en attente',
      statRefunds: 'Remboursements',
      colPayment: 'Paiement',
      colMethod: 'Méthode',
      invoice: 'Facture',
      paymentDetail: 'Détail du paiement',
      printInvoice: 'Imprimer la facture',
      methodCard: 'Carte',
      methodCash: 'Espèces',
      methodTransfer: 'Virement',
      methodOther: 'Autre',
      invoiceBilledTo: 'Facturé à',
      invoiceDesc: 'Prestation de traduction — commande',
      invoiceTotal: 'Total',
      invoiceNo: 'Facture n°',
    },
    translator: {
      title: 'Traducteur',
      navHome: 'Tableau de bord',
      navAvailability: 'Disponibilité',
      navMissions: 'Missions',
      navDocs: 'Documents',
      navProfile: 'Mon profil',
      homeTitle: 'Vos missions',
      homeSubtitle: 'Gérez vos traductions assignées et deadlines.',
      statOpen: 'Missions ouvertes',
      statProgress: 'En cours',
      statDone: 'Livrées',
      statDueSoon: 'Échéance < 48h',
      statOverdue: 'En retard',
      recentMissions: 'Missions récentes',
      priorityMissions: 'À traiter en priorité',
      missionsTitle: 'Missions',
      missionsSubtitle: 'Toutes les missions qui vous sont assignées.',
      colClient: 'Client',
      colDeadline: 'Échéance',
      profileTitle: 'Mon profil traducteur',
      profileSubtitle: 'Compétences, paires de langues et disponibilité.',
      updateStatus: 'Mettre à jour',
      uploadFinal: 'Envoyer le document final',
      searchMissions: 'Rechercher une mission…',
      filterAll: 'Toutes',
      kpiOpen: 'Assignées, non démarrées',
      kpiProgress: 'En cours de traduction',
      kpiDueSoon: 'À livrer bientôt',
      kpiOverdue: 'Deadline dépassée',
      respondTitle: 'Répondre à la mission',
      respondHint: 'Acceptez ou refusez avant de démarrer le travail.',
      acceptMission: 'Accepter',
      refuseMission: 'Refuser',
      refuseTitle: 'Refuser la mission',
      refuseHint: 'Indiquez le motif du refus. L’administration sera informée et la mission sera proposée à un autre professionnel.',
      motifLabel: 'Motif du refus',
      motifUnavailable: 'Indisponible',
      motifDeadline: 'Délai trop court',
      motifSkill: 'Compétence / service non adapté',
      motifWorkload: 'Charge de travail',
      motifOther: 'Autre',
      motifNote: 'Précision (optionnel)',
      confirmRefuse: 'Confirmer le refus',
      recipient: 'Destinataire',
      administration: 'Administration',
      mNew: 'Nouvelles (à accepter)',
      mAccepted: 'Acceptées',
      mToDeliver: 'À livrer',
      mDone: 'Terminées',
      filterService: 'Prestation',
      sortDeadlineNear: 'Échéance proche',
      sortDeadlineFar: 'Échéance lointaine',
      sortRecent: 'Plus récentes',
      sortLabel: 'Tri',
      viewMission: 'Voir la mission',
      pagesLabel: 'pages',
      colOrder: 'Commande',
      colDate: 'Date',
      colAmount: 'Montant',
      secInfos: 'Informations',
      secDocs: 'Documents',
      docsClient: 'Documents fournis par le client',
      docsWork: 'Documents de travail',
      docsDeliver: 'Documents à livrer',
      secInstructions: 'Instructions',
      clientNotes: 'Consignes du client',
      adminNotesLabel: 'Instructions de l’administration',
      secComm: 'Communication',
      contactClient: 'Contacter le client',
      contactAdmin: 'Contacter l’administration',
      secActions: 'Actions',
      secHistory: 'Historique',
      missionAssigned: 'Mission affectée',
      confirmTitle: 'Confirmer l’action',
      confirmText: 'Voulez-vous vraiment continuer ? Cette action sera enregistrée sur la mission.',
      confirmBtn: 'Confirmer',
      uploadDraft: 'Déposer un document de travail',
      uploadFinalDoc: 'Déposer le document final',
      viewDoc: 'Voir le document',
    },
    admin: {
      title: 'Admin',
      navHome: 'Tableau de bord',
      navOrders: 'Commandes',
      navQuotes: 'Devis',
      navInvoices: 'Factures',
      navMessages: 'Messages',
      navLanguages: 'Langues',
      navServices: 'Services',
      navUsers: 'Utilisateurs',
      navTranslators: 'Traducteurs',
      navVerifiers: 'Vérificateurs',
      homeTitle: 'Administration',
      homeSubtitle: 'Pilotage des commandes, utilisateurs et réseau.',
      statOrders: 'Commandes',
      statUsers: 'Utilisateurs',
      statTranslators: 'Traducteurs',
      statPending: 'En attente',
      statOverdue: 'En retard',
      statDueSoon: 'Échéance < 48h',
      statPipeline: 'Pipeline',
      statInProgress: 'En cours',
      statReady: 'Prêtes',
      kpiQueueHint: 'À assigner',
      kpiOverdueHint: 'Action immédiate',
      kpiDueSoonHint: 'Sous 48 heures',
      kpiUnpaid: 'Impayées',
      pendingQueue: 'File d’attente',
      urgentTitle: 'Prioritaires / urgentes',
      availableTranslators: 'Traducteurs dispo',
      overdueTag: 'En retard',
      dueSoonTag: 'Bientôt due',
      opsTitle: 'Centre opérations',
      opsText: 'Filtrez par statut / paiement, priorisez et assignez avec matching De→Vers.',
      recentOrders: 'Dernières commandes',
      ordersTitle: 'Commandes',
      ordersSubtitle: 'Suivi global, filtres et affectation intelligente.',
      colClient: 'Client',
      colTranslator: 'Traducteur',
      colTotal: 'Total',
      colPriority: 'Priorité',
      colPayment: 'Paiement',
      colStatus: 'Statut',
      colCode: 'Code',
      searchOrders: 'Code, document, langues…',
      searchUsers: 'Nom ou email…',
      searchTranslators: 'Nom, email, paires…',
      filterAll: 'Toutes',
      filterMatch: 'Compatibles',
      filterPaymentAll: 'Tous paiements',
      pickBest: 'Meilleur match',
      willCreateMission: 'Une mission sera créée avec le document source pour traduction.',
      assignNotes: 'Note pour le traducteur',
      assignNotesHint: 'Consignes, priorité, format attendu…',
      assignError: 'Impossible d’assigner. Réessayez.',
      cancel: 'Annuler',
      manageOrder: 'Gestion avancée',
      adminNotes: 'Notes internes',
      usersTitle: 'Utilisateurs',
      usersSubtitle: 'Comptes enregistrés sur la plateforme.',
      colName: 'Nom',
      colEmail: 'Email',
      colRole: 'Rôle',
      translatorsTitle: 'Traducteurs',
      translatorsSubtitle: 'Réseau de traducteurs et disponibilité.',
      colLangs: 'Langues',
      colMissions: 'Missions',
      assignTitle: 'Assigner un traducteur',
      manageProfiles: 'Gérer les profils',
      createTranslator: 'Créer un traducteur',
      password: 'Mot de passe temporaire',
      quotesTitle: 'Devis',
      quotesSubtitle: 'Créez, tarifiez et envoyez les devis aux clients.',
      createQuote: 'Créer un devis',
      answerQuote: 'Tarifer / envoyer',
      sendQuote: 'Envoyer au client',
      deadline: 'Échéance',
      serviceType: 'Type',
      message: 'Message',
      languagesTitle: 'Langues',
      languagesSubtitle: 'Catalogue des langues proposées.',
      addLanguage: 'Ajouter une langue',
      importLanguages: 'Importer les langues (API)',
      importDone: 'Import terminé',
      servicesTitle: 'Services',
      servicesSubtitle: 'Catalogue des services offerts.',
      addService: 'Ajouter un service',
      serviceTitle: 'Titre',
      serviceCategory: 'Catégorie',
      catTranslation: 'Traduction',
      catInterpreting: 'Interprétariat',
      invoicesTitle: 'Factures',
      invoicesSubtitle: 'Émission et suivi des paiements.',
      createInvoice: 'Créer une facture',
      markPaid: 'Marquer payée',
      messagesTitle: 'Messages',
      messagesSubtitle: 'Conversations avec les clients et les professionnels.',
      sendMessage: 'Envoyer',
      thread: 'Fil',
      allThreads: 'Tous les fils',
      recipient: 'Destinataire',
      administration: 'Administration',
      activate: 'Activer',
      deactivate: 'Désactiver',
      delete: 'Supprimer',
      statDone: 'Terminées',
      statRevenue: 'Chiffre d’affaires',
      statPendingPayments: 'Paiements en attente',
      statNewClients: 'Nouveaux clients',
      statActivePros: 'Traducteurs & interprètes actifs',
      hintNewClients: '30 derniers jours',
      hintInterpreters: 'interprètes',
      hintRevenue: 'Commandes payées',
      hintPaymentsAmount: 'TND à encaisser',
      alertsTitle: 'Alertes & actions à traiter',
      alertUnassigned: 'Commandes sans professionnel affecté',
      alertApplications: 'Candidatures à valider',
      alertReviews: 'Documents en attente de vérification',
      alertPayments: 'Paiements en attente',
      alertDueSoon: 'Commandes dont le délai approche',
      noAlerts: 'Aucune alerte — tout est en ordre.',
      chartsTitle: 'Activité & répartition',
      chartOrders: 'Commandes par période',
      chartRevenue: 'Chiffre d’affaires par période',
      chartServices: 'Commandes par type de service',
      chartCategories: 'Traduction / Interprétariat',
      last6Months: '6 derniers mois',
      activityTitle: 'Activité récente',
      recentPayments: 'Derniers paiements',
      recentApplications: 'Nouvelles candidatures',
      recentDocuments: 'Nouveaux documents à traiter',
      pendingReviewsTitle: 'Vérifications en attente',
      colAmount: 'Montant',
      colDate: 'Date',
    },
    legal: {
      title: 'Vérificateur',
      navHome: 'Tableau de bord',
      navVerifications: 'Mes vérifications',
      navProfile: 'Mon profil',
      homeTitle: 'Vos vérifications',
      homeSubtitle: 'Gérez les contrôles juridiques et notariaux assignés.',
      statToReview: 'À vérifier',
      statCorrections: 'Corrections',
      statValidated: 'Validés',
      statDueSoon: 'Échéance < 48h',
      statOverdue: 'En retard',
      recentVerifications: 'Vérifications récentes',
      urgentVerifications: 'Vérifications urgentes',
      verificationsTitle: 'Mes vérifications',
      verificationsSubtitle: 'Toutes les commandes en attente de contrôle.',
      colClient: 'Client',
      colDocument: 'Document',
      colLangs: 'Langues',
      colStatus: 'Statut',
      colDeadline: 'Échéance',
      colType: 'Type',
      filterAll: 'Toutes',
      filterPending: 'À vérifier',
      filterCorrection: 'Corrections',
      filterValidated: 'Validées',
      detailTitle: 'Détail de la vérification',
      detailSubtitle: 'Contrôlez les documents et donnez votre avis.',
      originalDocs: 'Documents originaux',
      translatedDocs: 'Traductions',
      checklist: 'Checklist',
      comments: 'Commentaires',
      addComment: 'Ajouter une observation',
      requestCorrection: 'Demander une correction',
      validate: 'Valider',
      reject: 'Refuser',
      correctionReason: 'Motif de la correction',
      rejectReason: 'Motif du refus',
      reasonRequired: 'Un motif est obligatoire',
      profileTitle: 'Profil vérificateur',
      profileSubtitle: 'Informations professionnelles visibles par l’équipe.',
    },
  },
  ar: {
    backSite: 'العودة إلى الموقع',
    logout: 'تسجيل الخروج',
    welcome: 'مرحباً',
    overview: 'نظرة عامة',
    profile: 'الملف الشخصي',
    save: 'حفظ',
    saved: 'تم تحديث الملف',
    refresh: 'تحديث',
    quickActions: 'إجراءات سريعة',
    navMessages: 'الرسائل',
    edit: 'تعديل الملف الشخصي',
    back: 'رجوع',
    empty: 'لا توجد عناصر حالياً.',
    actions: 'إجراءات',
    assign: 'تعيين',
    assignTo: 'تعيين إلى',
    changeStatus: 'تغيير الحالة',
    view: 'عرض',
    upload: 'رفع ملف',
    startMission: 'بدء',
    markReady: 'جاهز',
    markDelivered: 'تم التسليم',
    addTranslator: 'إضافة مترجم',
    editProfile: 'تعديل الملف',
    send: 'Envoyer',
    cancel: 'Annuler',
    specialties: 'التخصصات',
    langPairs: 'أزواج اللغات',
    experience: 'سنوات الخبرة',
    sworn: 'محلف',
    bio: 'نبذة',
    pageRate: 'السعر / صفحة',
    availability: 'التوفر',
    timeline: 'المتابعة',
    deliverables: 'التسليمات',
    orderDetail: 'تفاصيل الطلب',
    missionDetail: 'تفاصيل المهمة',
    noTranslator: 'لا يوجد مترجم',
    selectTranslator: 'اختر مترجماً',
    confirmAssign: 'تأكيد التعيين',
    matchScore: 'درجة التوافق',
    payment: {
      unpaid: 'غير مدفوع',
      pending: 'قيد الدفع',
      paid: 'مدفوع',
      refunded: 'مسترد',
      failed: 'فشل',
    },
    priority: {
      normal: 'عادية',
      high: 'عالية',
      urgent: 'عاجلة',
    },
    status: {
      pending: 'قيد الانتظار',
      in_progress: 'قيد التنفيذ',
      ready: 'جاهز',
      delivered: 'تم التسليم',
      assigned: 'معيّن',
      answered: 'تم الرد',
      sent: 'مُرسل',
      accepted: 'مقبول',
      rejected: 'مرفوض',
      refused: 'مرفوض',
      issued: 'صادرة',
      paid: 'مدفوعة',
      draft: 'مسودة',
      active: 'نشط',
      busy: 'مشغول',
      unavailable: 'غير متاح',
      cancelled: 'ملغى',
      toAssign: 'بانتظار التعيين',
      completed: 'مكتملة',
      request_sent: 'تم إرسال الطلب',
      pending_review: 'قيد المراجعة',
      quote_sent: 'تم إرسال العرض',
      quote_accepted: 'تم قبول العرض',
      quote_expired: 'انتهت صلاحية العرض',
      payment_pending: 'بانتظار الدفع',
      payment_failed: 'فشل الدفع',
      translator_to_assign: 'بانتظار التعيين',
      translator_unavailable: 'المهني غير متوفر',
      translator_assigned: 'تم تعيين مهني',
      translation_in_progress: 'الترجمة قيد التنفيذ',
      translation_submitted: 'تم تقديم الترجمة',
      verification_requested: 'تم طلب التحقق',
      lawyer_notary_in_progress: 'التحقق قيد التنفيذ',
      new_version: 'نسخة جديدة',
      verification_validated: 'تم التحقق',
      final_control: 'المراقبة النهائية',
      ready_to_deliver: 'جاهزة للتسليم',
      correction_requested: 'Correction demandée',
      validated: 'Validé',
    },
    demoHint: 'حسابات تجريبية',
    roleClient: 'عميل',
    roleTranslator: 'مترجم',
    roleAdmin: 'مدير',
    roleLegal: 'Vérificateur',
    client: {
      title: 'عميل',
      navHome: 'لوحة التحكم',
      navOrders: 'طلباتي',
      navQuotes: 'عروض الأسعار',
      navInvoices: 'الفواتير',
      navMessages: 'الرسائل',
      navProfile: 'ملفي',
      homeTitle: 'مساحتك في ترجملك',
      homeSubtitle: 'تابع طلباتك وعروض الأسعار والوثائق المعتمدة.',
      statOrders: 'الطلبات',
      statQuotes: 'عروض الأسعار',
      statReady: 'وثائق جاهزة',
      statDone: 'منتهية',
      colPro: 'المهني',
      ctaOrder: 'طلب جديد',
      ctaQuote: 'طلب عرض أسعار',
      ctaOrders: 'عرض طلباتي',
      ctaDocs: 'وثائقي',
      ctaPayments: 'مدفوعاتي',
      ctaMessages: 'الرسائل',
      recentOrders: 'أحدث الطلبات',
      ordersTitle: 'طلباتي',
      ordersSubtitle: 'سجل وحالة ترجماتك.',
      colId: 'الرقم',
      colDocument: 'الوثيقة',
      colLangs: 'اللغات',
      colStatus: 'الحالة',
      colPrice: 'السعر',
      colDate: 'التاريخ',
      quotesTitle: 'عروض الأسعار',
      quotesSubtitle: 'الطلبات الجارية والمجاب عنها.',
      colType: 'النوع',
      acceptQuote: 'قبول',
      rejectQuote: 'رفض',
      invoicesTitle: 'فواتيري',
      invoicesSubtitle: 'الفواتير الصادرة لطلباتك.',
      messagesTitle: 'الرسائل',
      messagesSubtitle: 'تواصل مع فريق ترجملك.',
      messageLabel: 'رسالتك',
      sendMessage: 'إرسال',
      recipient: 'المستلم',
      administration: 'الإدارة',
      profileTitle: 'ملفي الشخصي',
      profileSubtitle: 'حدّث معلومات الاتصال.',
      fieldName: 'الاسم الكامل',
      fieldEmail: 'البريد',
      fieldPhone: 'الهاتف',
      fieldCity: 'المدينة',
      statProgress: 'قيد المعالجة',
      searchOrders: 'ابحث عن طلب…',
      filterAll: 'الكل',
      filterService: 'الخدمة',
      catTranslation: 'ترجمة',
      catInterpreting: 'ترجمة فورية',
      viewOrder: 'عرض الطلب',
      orderedOn: 'تم الطلب في',
      awaitingTitle: 'بانتظار التعيين',
      awaitingText: 'نبحث عن مهني مناسب لطلبك.',
      proLabel: 'المهني',
      secSummary: 'ملخص',
      secProgress: 'التقدم',
      secDocs: 'الوثائق',
      secDocsSent: 'الوثائق المرسلة',
      secDocsFinal: 'الوثائق النهائية المتاحة',
      download: 'تحميل',
      secPro: 'المهني',
      contactPro: 'مراسلة المهني',
      secPayment: 'الدفع',
      payAmount: 'المبلغ',
      payMethod: 'الطريقة',
      payDate: 'التاريخ',
      payRef: 'المرجع',
      payAwaitingPro: 'الدفع متاح فور قبول مهني لطلبك.',
      viewPayments: 'عرض مدفوعاتي',
      secDelivery: 'التسليم',
      deliveryMode: 'طريقة التسليم',
      deliveryAddress: 'العنوان',
      deliveryPlanned: 'التاريخ المتوقع',
      deliveryTracking: 'رقم التتبع',
      secMessages: 'الرسائل',
      messagesHint: 'محادثة مرتبطة بهذا الطلب: أنت والمهني المعيّن والإدارة.',
      goMessages: 'فتح المراسلة',
      secHistory: 'السجل',
      stepCreated: 'تم إنشاء الطلب',
      stepPaid: 'الدفع',
      stepAssigned: 'تم تعيين المهني',
      stepProgress: 'الترجمة جارية',
      stepVerify: 'التحقق',
      stepDelivery: 'التسليم',
      stepDone: 'منتهية',
      documentsTitle: 'وثائقي',
      documentsSubtitle: 'اعثر على الوثائق المرسلة والوثائق النهائية لطلباتك.',
      searchDocs: 'ابحث عن وثيقة…',
      colDoc: 'الوثيقة',
      colOrder: 'الطلب',
      docType: 'النوع',
      docSent: 'وثيقة مرسلة',
      docInProgress: 'وثيقة قيد المعالجة',
      docTranslated: 'وثيقة مترجمة',
      docFinal: 'وثيقة نهائية',
      docAvailable: 'متاحة',
      filtersTitle: 'عوامل التصفية',
      resetFilters: 'إعادة التعيين',
      searchLabel: 'بحث',
      payLabel: 'الدفع',
      sortLabel: 'الترتيب',
      sortRecent: 'الأحدث',
      sortOldest: 'الأقدم',
      sortDeadline: 'الموعد الأقرب',
      sortAmount: 'المبلغ (تنازلي)',
      fromLabel: 'من',
      toLabel: 'إلى',
      overdueLabel: 'متأخرة',
      kpiAll: 'إجمالي الحساب',
      kpiProgress: 'قيد الانتظار أو التنفيذ',
      kpiReady: 'جاهز / مسلّم',
      kpiQuotes: 'طلبات مفتوحة',
      statTotalPaid: 'إجمالي المدفوع',
      statPendingPayments: 'مدفوعات معلّقة',
      statRefunds: 'الاستردادات',
      colPayment: 'الدفع',
      colMethod: 'الطريقة',
      invoice: 'الفاتورة',
      paymentDetail: 'تفاصيل الدفع',
      printInvoice: 'طباعة الفاتورة',
      methodCard: 'بطاقة',
      methodCash: 'نقدًا',
      methodTransfer: 'تحويل',
      methodOther: 'أخرى',
      invoiceBilledTo: 'فاتورة إلى',
      invoiceDesc: 'خدمة ترجمة — طلب',
      invoiceTotal: 'الإجمالي',
      invoiceNo: 'فاتورة رقم',
    },
    translator: {
      title: 'مترجم',
      navAvailability: 'التوفر',
      navHome: 'لوحة التحكم',
      navMissions: 'المهام',
      navDocs: 'الوثائق',
      navProfile: 'ملفي',
      homeTitle: 'مهامك',
      homeSubtitle: 'أدِر الترجمات المعيّنة والمواعيد النهائية.',
      statOpen: 'مهام مفتوحة',
      statProgress: 'قيد التنفيذ',
      statDone: 'مسلّمة',
      statDueSoon: 'موعد < 48س',
      statOverdue: 'متأخرة',
      recentMissions: 'أحدث المهام',
      priorityMissions: 'أولوية المعالجة',
      missionsTitle: 'المهام',
      missionsSubtitle: 'كل المهام المعيّنة لك.',
      colClient: 'العميل',
      colDeadline: 'الموعد',
      profileTitle: 'ملف المترجم',
      profileSubtitle: 'معلومات يراها فريق ترجملك.',
      searchMissions: 'ابحث عن مهمة…',
      filterAll: 'الكل',
      kpiOpen: 'معيّنة ولم تبدأ',
      kpiProgress: 'قيد الترجمة',
      kpiDueSoon: 'تسليم قريب',
      kpiOverdue: 'تجاوز الموعد',
      respondTitle: 'الرد على المهمة',
      respondHint: 'اقبل أو ارفض قبل بدء العمل.',
      acceptMission: 'قبول',
      refuseMission: 'رفض',
      refuseTitle: 'رفض المهمة',
      refuseHint: 'حدّد سبب الرفض. سيتم إعلام الإدارة واقتراح المهمة على مترجم آخر.',
      motifLabel: 'سبب الرفض',
      motifUnavailable: 'غير متوفر',
      motifDeadline: 'الموعد النهائي قصير جداً',
      motifSkill: 'المهارة / الخدمة غير مناسبة',
      motifWorkload: 'عبء العمل',
      motifOther: 'أخرى',
      motifNote: 'توضيح (اختياري)',
      confirmRefuse: 'تأكيد الرفض',
      recipient: 'المستلم',
      administration: 'الإدارة',
      mNew: 'جديدة (للقبول)',
      mAccepted: 'مقبولة',
      mToDeliver: 'للتسليم',
      mDone: 'منتهية',
      filterService: 'نوع الخدمة',
      sortDeadlineNear: 'أقرب موعد',
      sortDeadlineFar: 'أبعد موعد',
      sortRecent: 'الأحدث',
      sortLabel: 'الترتيب',
      viewMission: 'عرض المهمة',
      pagesLabel: 'صفحة',
      colOrder: 'الطلب',
      colDate: 'التاريخ',
      colAmount: 'المبلغ',
      secInfos: 'المعلومات',
      secDocs: 'الوثائق',
      docsClient: 'وثائق العميل',
      docsWork: 'وثائق العمل',
      docsDeliver: 'وثائق التسليم',
      secInstructions: 'التعليمات',
      clientNotes: 'تعليمات العميل',
      adminNotesLabel: 'تعليمات الإدارة',
      secComm: 'التواصل',
      contactClient: 'مراسلة العميل',
      contactAdmin: 'مراسلة الإدارة',
      secActions: 'الإجراءات',
      secHistory: 'السجل',
      missionAssigned: 'تم إسناد المهمة',
      confirmTitle: 'تأكيد الإجراء',
      confirmText: 'هل تريد المتابعة؟ سيتم تسجيل هذا الإجراء في المهمة.',
      confirmBtn: 'تأكيد',
      uploadDraft: 'إيداع وثيقة عمل',
      uploadFinalDoc: 'إيداع الوثيقة النهائية',
      viewDoc: 'عرض الوثيقة',
    },
    admin: {
      title: 'إدارة',
      navHome: 'لوحة التحكم',
      navOrders: 'الطلبات',
      navQuotes: 'عروض الأسعار',
      navInvoices: 'الفواتير',
      navMessages: 'الرسائل',
      navLanguages: 'اللغات',
      navServices: 'الخدمات',
      navUsers: 'المستخدمون',
      navTranslators: 'المترجمون',
      navVerifiers: 'Vérificateurs',
      homeTitle: 'الإدارة',
      homeSubtitle: 'إدارة الطلبات والمستخدمين والشبكة.',
      statOrders: 'الطلبات',
      statUsers: 'المستخدمون',
      statTranslators: 'المترجمون',
      statPending: 'قيد الانتظار',
      statOverdue: 'متأخرة',
      statDueSoon: 'موعد < 48س',
      statPipeline: 'القيمة',
      statInProgress: 'قيد التنفيذ',
      statReady: 'جاهزة',
      kpiQueueHint: 'بانتظار التعيين',
      kpiOverdueHint: 'إجراء فوري',
      kpiDueSoonHint: 'خلال 48 ساعة',
      kpiUnpaid: 'غير مدفوعة',
      pendingQueue: 'قائمة الانتظار',
      urgentTitle: 'عاجلة / أولوية',
      availableTranslators: 'مترجمون متاحون',
      overdueTag: 'متأخر',
      dueSoonTag: 'قريب',
      opsTitle: 'مركز العمليات',
      opsText: 'صفِّ حسب الحالة/الدفع، حدّد الأولوية وعيّن بالمطابقة.',
      recentOrders: 'آخر الطلبات',
      ordersTitle: 'الطلبات',
      ordersSubtitle: 'متابعة شاملة وفلاتر وتعيين ذكي.',
      colClient: 'العميل',
      colTranslator: 'المترجم',
      colTotal: 'الإجمالي',
      colPriority: 'الأولوية',
      colPayment: 'الدفع',
      colStatus: 'الحالة',
      searchOrders: 'رمز، وثيقة، لغات…',
      searchUsers: 'الاسم أو البريد…',
      searchTranslators: 'الاسم، البريد، الأزواج…',
      filterAll: 'الكل',
      filterMatch: 'متوافقون',
      filterPaymentAll: 'كل المدفوعات',
      pickBest: 'أفضل تطابق',
      willCreateMission: 'سيتم إنشاء مهمة مع وثيقة المصدر للترجمة.',
      assignNotes: 'ملاحظة للمترجم',
      assignNotesHint: 'تعليمات، أولوية، الصيغة المطلوبة…',
      assignError: 'تعذر التعيين. أعد المحاولة.',
      cancel: 'إلغاء',
      manageOrder: 'إدارة متقدمة',
      adminNotes: 'ملاحظات داخلية',
      usersTitle: 'المستخدمون',
      usersSubtitle: 'الحسابات المسجلة على المنصة.',
      colName: 'الاسم',
      colEmail: 'البريد',
      colRole: 'الدور',
      translatorsTitle: 'المترجمون',
      translatorsSubtitle: 'شبكة المترجمين والتوافر.',
      colLangs: 'اللغات',
      colMissions: 'المهام',
      quotesTitle: 'عروض الأسعار',
      quotesSubtitle: 'إنشاء وتسعير وإرسال العروض.',
      createQuote: 'إنشاء عرض',
      answerQuote: 'تسعير / إرسال',
      sendQuote: 'إرسال للعميل',
      deadline: 'الموعد',
      serviceType: 'النوع',
      message: 'رسالة',
      languagesTitle: 'اللغات',
      languagesSubtitle: 'كتالوج اللغات.',
      addLanguage: 'إضافة لغة',
      importLanguages: 'استيراد اللغات (API)',
      importDone: 'اكتمل الاستيراد',
      servicesTitle: 'الخدمات',
      servicesSubtitle: 'كتالوج الخدمات.',
      addService: 'إضافة خدمة',
      serviceTitle: 'العنوان',
      serviceCategory: 'الفئة',
      catTranslation: 'ترجمة',
      catInterpreting: 'ترجمة فورية',
      invoicesTitle: 'الفواتير',
      invoicesSubtitle: 'إصدار ومتابعة الدفع.',
      createInvoice: 'إنشاء فاتورة',
      markPaid: 'تعيين كمدفوعة',
      messagesTitle: 'الرسائل',
      messagesSubtitle: 'محادثات العملاء والمهنيين.',
      sendMessage: 'إرسال',
      thread: 'المحادثة',
      allThreads: 'كل المحادثات',
      recipient: 'المستلم',
      administration: 'الإدارة',
      activate: 'تفعيل',
      deactivate: 'تعطيل',
      delete: 'حذف',
      statDone: 'منتهية',
      statRevenue: 'رقم الأعمال',
      statPendingPayments: 'مدفوعات معلقة',
      statNewClients: 'عملاء جدد',
      statActivePros: 'مترجمون ومترجمون فوريون نشطون',
      hintNewClients: 'آخر 30 يوماً',
      hintInterpreters: 'مترجمون فوريون',
      hintRevenue: 'طلبات مدفوعة',
      hintPaymentsAmount: 'د.ت للتحصيل',
      alertsTitle: 'تنبيهات وإجراءات',
      alertUnassigned: 'طلبات بدون مهني معيّن',
      alertApplications: 'ترشيحات للتحقق',
      alertReviews: 'وثائق بانتظار التدقيق',
      alertPayments: 'مدفوعات معلقة',
      alertDueSoon: 'طلبات يقترب موعدها',
      noAlerts: 'لا تنبيهات — كل شيء على ما يرام.',
      chartsTitle: 'النشاط والتوزيع',
      chartOrders: 'الطلبات حسب الفترة',
      chartRevenue: 'رقم الأعمال حسب الفترة',
      chartServices: 'الطلبات حسب نوع الخدمة',
      chartCategories: 'ترجمة / ترجمة فورية',
      last6Months: 'آخر 6 أشهر',
      activityTitle: 'النشاط الأخير',
      recentPayments: 'آخر المدفوعات',
      recentApplications: 'ترشيحات جديدة',
      recentDocuments: 'وثائق جديدة للمعالجة',
      pendingReviewsTitle: 'تدقيقات معلقة',
      colAmount: 'المبلغ',
      colDate: 'التاريخ',
    },
    legal: {
      title: 'Vérificateur',
      navHome: 'Tableau de bord',
      navVerifications: 'Mes vérifications',
      navProfile: 'Mon profil',
      homeTitle: 'Vos vérifications',
      homeSubtitle: 'Gérez les contrôles juridiques et notariaux assignés.',
      statToReview: 'À vérifier',
      statCorrections: 'Corrections',
      statValidated: 'Validés',
      statDueSoon: 'Échéance < 48h',
      statOverdue: 'En retard',
      recentVerifications: 'Vérifications récentes',
      urgentVerifications: 'Vérifications urgentes',
      verificationsTitle: 'Mes vérifications',
      verificationsSubtitle: 'Toutes les commandes en attente de contrôle.',
      colClient: 'Client',
      colDocument: 'Document',
      colLangs: 'Langues',
      colStatus: 'Statut',
      colDeadline: 'Échéance',
      colType: 'Type',
      filterAll: 'Toutes',
      filterPending: 'À vérifier',
      filterCorrection: 'Corrections',
      filterValidated: 'Validées',
      detailTitle: 'Détail de la vérification',
      detailSubtitle: 'Contrôlez les documents et donnez votre avis.',
      originalDocs: 'Documents originaux',
      translatedDocs: 'Traductions',
      checklist: 'Checklist',
      comments: 'Commentaires',
      addComment: 'Ajouter une observation',
      requestCorrection: 'Demander une correction',
      validate: 'Valider',
      reject: 'Refuser',
      correctionReason: 'Motif de la correction',
      rejectReason: 'Motif du refus',
      reasonRequired: 'Un motif est obligatoire',
      profileTitle: 'Profil vérificateur',
      profileSubtitle: 'Informations professionnelles visibles par l’équipe.',
    },
  },
  en: {
    backSite: 'Back to site',
    logout: 'Log out',
    welcome: 'Hello',
    overview: 'Overview',
    profile: 'Profile',
    save: 'Save',
    saved: 'Profile updated',
    refresh: 'Refresh',
    quickActions: 'Quick actions',
    navMessages: 'Messages',
    edit: 'Edit profile',
    back: 'Back',
    empty: 'Nothing here yet.',
    actions: 'Actions',
    assign: 'Assign',
    assignTo: 'Assign to',
    changeStatus: 'Change status',
    view: 'View',
    upload: 'Upload file',
    startMission: 'Start',
    markReady: 'Mark ready',
    markDelivered: 'Mark delivered',
    addTranslator: 'Add translator',
    editProfile: 'Edit profile',
    send: 'Send',
    cancel: 'Cancel',
    specialties: 'Specialties',
    langPairs: 'Language pairs',
    experience: 'Years of experience',
    sworn: 'Sworn',
    bio: 'Bio',
    pageRate: 'Rate / page',
    availability: 'Availability',
    timeline: 'Timeline',
    deliverables: 'Deliverables',
    orderDetail: 'Order detail',
    missionDetail: 'Mission detail',
    noTranslator: 'No translator',
    selectTranslator: 'Select a translator',
    confirmAssign: 'Confirm assignment',
    fromLang: 'From',
    toLang: 'To',
    addPair: 'Add a pair',
    assignHowTitle: 'How an order is assigned',
    assignHowText: 'Admin opens the order, picks a translator whose From→To pairs match, then confirms. A mission is created automatically.',
    matchLangs: 'Translators matching',
    noMatch: 'No active translator for this pair. Showing all active translators.',
    clientInfoTitle: 'Useful info',
    clientInfoOrders: 'Track each order: pending → assigned → in progress → ready → delivered.',
    clientInfoFiles: 'When status is Ready or Delivered, download your translated files here.',
    translatorInfoTitle: 'Your activity',
    translatorInfoPairs: 'Declare precise pairs: source language (From) → target language (To).',
    translatorInfoMissions: 'A mission appears here only after admin assignment.',
    howItWorks: 'How it works',
    matchScore: 'Match score',
    payment: {
      unpaid: 'Unpaid',
      pending: 'Payment pending',
      paid: 'Paid',
      refunded: 'Refunded',
      failed: 'Failed',
    },
    priority: {
      normal: 'Normal',
      high: 'High',
      urgent: 'Urgent',
    },
    status: {
      pending: 'Pending',
      in_progress: 'In progress',
      ready: 'Ready',
      delivered: 'Delivered',
      assigned: 'Assigned',
      answered: 'Answered',
      sent: 'Sent',
      accepted: 'Accepted',
      rejected: 'Rejected',
      refused: 'Refused',
      issued: 'Issued',
      paid: 'Paid',
      draft: 'Draft',
      active: 'Active',
      busy: 'Busy',
      unavailable: 'Unavailable',
      cancelled: 'Cancelled',
      toAssign: 'Awaiting assignment',
      completed: 'Completed',
      request_sent: 'Request sent',
      pending_review: 'Under review',
      quote_sent: 'Quote sent',
      quote_accepted: 'Quote accepted',
      quote_expired: 'Quote expired',
      payment_pending: 'Awaiting payment',
      payment_failed: 'Payment failed',
      translator_to_assign: 'Awaiting assignment',
      translator_unavailable: 'Professional unavailable',
      translator_assigned: 'Professional assigned',
      translation_in_progress: 'Translation in progress',
      translation_submitted: 'Translation submitted',
      verification_requested: 'Verification requested',
      lawyer_notary_in_progress: 'Verification in progress',
      new_version: 'New version',
      verification_validated: 'Verification validated',
      final_control: 'Final check',
      ready_to_deliver: 'Ready to deliver',
      correction_requested: 'Correction requested',
      validated: 'Validated',
    },
    demoHint: 'Demo accounts',
    roleClient: 'Client',
    roleTranslator: 'Translator',
    roleAdmin: 'Admin',
    roleLegal: 'Verifier',
    client: {
      title: 'Client',
      navHome: 'Dashboard',
      navOrders: 'My orders',
      navQuotes: 'My quotes',
      navInvoices: 'Invoices',
      navMessages: 'Messages',
      navProfile: 'My profile',
      homeTitle: 'Your Tarjemlek space',
      homeSubtitle: 'Track orders, quotes and certified documents.',
      statOrders: 'Orders',
      statQuotes: 'Quotes',
      statReady: 'Ready documents',
      statDone: 'Completed',
      colPro: 'Professional',
      ctaOrder: 'New order',
      ctaQuote: 'Request a quote',
      ctaOrders: 'View my orders',
      ctaDocs: 'My documents',
      ctaPayments: 'My payments',
      ctaMessages: 'Messages',
      recentOrders: 'Recent orders',
      ordersTitle: 'My orders',
      ordersSubtitle: 'History and status of your translations.',
      colId: 'ID',
      colDocument: 'Document',
      colLangs: 'Languages',
      colStatus: 'Status',
      colPrice: 'Price',
      colDate: 'Date',
      quotesTitle: 'My quotes',
      quotesSubtitle: 'Open and answered quote requests.',
      colType: 'Type',
      acceptQuote: 'Accept',
      rejectQuote: 'Reject',
      invoicesTitle: 'My invoices',
      invoicesSubtitle: 'Invoices issued for your orders.',
      messagesTitle: 'Messages',
      messagesSubtitle: 'Chat with the Tarjemlek team.',
      messageLabel: 'Your message',
      sendMessage: 'Send',
      recipient: 'Recipient',
      administration: 'Administration',
      profileTitle: 'My profile',
      profileSubtitle: 'Update your contact details.',
      fieldName: 'Full name',
      fieldEmail: 'Email',
      fieldPhone: 'Phone',
      fieldCity: 'City',
      detailTitle: 'Order detail',
      detailSubtitle: 'Track your translation and downloadables.',
      backOrders: 'Back to orders',
      statProgress: 'In process',
      searchOrders: 'Search an order…',
      filterAll: 'All',
      filterService: 'Service',
      catTranslation: 'Translation',
      catInterpreting: 'Interpreting',
      viewOrder: 'View order',
      orderedOn: 'Ordered on',
      awaitingTitle: 'Awaiting assignment',
      awaitingText: 'We are looking for a professional matching your request.',
      proLabel: 'Professional',
      secSummary: 'Summary',
      secProgress: 'Progress',
      secDocs: 'Documents',
      secDocsSent: 'Submitted documents',
      secDocsFinal: 'Available final documents',
      download: 'Download',
      secPro: 'Professional',
      contactPro: 'Contact the professional',
      secPayment: 'Payment',
      payAmount: 'Amount',
      payMethod: 'Method',
      payDate: 'Date',
      payRef: 'Reference',
      payAwaitingPro: 'Payment becomes available once a professional accepts your order.',
      viewPayments: 'View my payments',
      secDelivery: 'Delivery',
      deliveryMode: 'Delivery mode',
      deliveryAddress: 'Address',
      deliveryPlanned: 'Expected date',
      deliveryTracking: 'Tracking number',
      secMessages: 'Messages',
      messagesHint: 'Conversation linked to this order: you, the assigned professional and the administration.',
      goMessages: 'Open messaging',
      secHistory: 'History',
      stepCreated: 'Order created',
      stepPaid: 'Payment',
      stepAssigned: 'Professional assigned',
      stepProgress: 'Translation in progress',
      stepVerify: 'Verification',
      stepDelivery: 'Delivery',
      stepDone: 'Completed',
      documentsTitle: 'My documents',
      documentsSubtitle: 'Find the submitted and final documents of your orders.',
      searchDocs: 'Search a document…',
      colDoc: 'Document',
      colOrder: 'Order',
      docType: 'Type',
      docSent: 'Submitted document',
      docInProgress: 'Document in progress',
      docTranslated: 'Translated document',
      docFinal: 'Final document',
      docAvailable: 'Available',
      filtersTitle: 'Filters',
      resetFilters: 'Reset',
      searchLabel: 'Search',
      payLabel: 'Payment',
      sortLabel: 'Sort',
      sortRecent: 'Most recent',
      sortOldest: 'Oldest',
      sortDeadline: 'Closest deadline',
      sortAmount: 'Amount (desc)',
      fromLabel: 'From',
      toLabel: 'To',
      overdueLabel: 'Overdue',
      kpiAll: 'Account total',
      kpiProgress: 'Pending or in progress',
      kpiReady: 'Ready / delivered',
      kpiQuotes: 'Open requests',
      statTotalPaid: 'Total paid',
      statPendingPayments: 'Pending payments',
      statRefunds: 'Refunds',
      colPayment: 'Payment',
      colMethod: 'Method',
      invoice: 'Invoice',
      paymentDetail: 'Payment details',
      printInvoice: 'Print invoice',
      methodCard: 'Card',
      methodCash: 'Cash',
      methodTransfer: 'Transfer',
      methodOther: 'Other',
      invoiceBilledTo: 'Billed to',
      invoiceDesc: 'Translation service — order',
      invoiceTotal: 'Total',
      invoiceNo: 'Invoice no.',
    },
    translator: {
      title: 'Translator',
      navAvailability: 'Availability',
      navHome: 'Dashboard',
      navMissions: 'Missions',
      navDocs: 'Documents',
      navProfile: 'My profile',
      homeTitle: 'Your missions',
      homeSubtitle: 'Manage assigned translations and deadlines.',
      statOpen: 'Open missions',
      statProgress: 'In progress',
      statDone: 'Delivered',
      statDueSoon: 'Due < 48h',
      statOverdue: 'Overdue',
      recentMissions: 'Recent missions',
      priorityMissions: 'Priority queue',
      missionsTitle: 'Missions',
      missionsSubtitle: 'All missions assigned to you.',
      colClient: 'Client',
      colDeadline: 'Deadline',
      profileTitle: 'Translator profile',
      profileSubtitle: 'Details visible to the Tarjemlek team.',
      searchMissions: 'Search a mission…',
      filterAll: 'All',
      kpiOpen: 'Assigned, not started',
      kpiProgress: 'Being translated',
      kpiDueSoon: 'Due soon',
      kpiOverdue: 'Past deadline',
      respondTitle: 'Respond to mission',
      respondHint: 'Accept or refuse before starting work.',
      acceptMission: 'Accept',
      refuseMission: 'Refuse',
      refuseTitle: 'Refuse mission',
      refuseHint: 'State the reason for refusal. The administration will be notified and the mission will be proposed to another professional.',
      motifLabel: 'Refusal reason',
      motifUnavailable: 'Unavailable',
      motifDeadline: 'Deadline too short',
      motifSkill: 'Skill / service not suitable',
      motifWorkload: 'Workload',
      motifOther: 'Other',
      motifNote: 'Details (optional)',
      confirmRefuse: 'Confirm refusal',
      recipient: 'Recipient',
      administration: 'Administration',
      mNew: 'New (to accept)',
      mAccepted: 'Accepted',
      mToDeliver: 'To deliver',
      mDone: 'Completed',
      filterService: 'Service type',
      sortDeadlineNear: 'Nearest deadline',
      sortDeadlineFar: 'Furthest deadline',
      sortRecent: 'Most recent',
      sortLabel: 'Sort',
      viewMission: 'View mission',
      pagesLabel: 'pages',
      colOrder: 'Order',
      colDate: 'Date',
      colAmount: 'Amount',
      secInfos: 'Information',
      secDocs: 'Documents',
      docsClient: 'Client documents',
      docsWork: 'Working documents',
      docsDeliver: 'Delivery documents',
      secInstructions: 'Instructions',
      clientNotes: 'Client instructions',
      adminNotesLabel: 'Administration instructions',
      secComm: 'Communication',
      contactClient: 'Contact the client',
      contactAdmin: 'Contact the administration',
      secActions: 'Actions',
      secHistory: 'History',
      missionAssigned: 'Mission assigned',
      confirmTitle: 'Confirm action',
      confirmText: 'Do you really want to continue? This action will be recorded on the mission.',
      confirmBtn: 'Confirm',
      uploadDraft: 'Upload a working document',
      uploadFinalDoc: 'Upload the final document',
      viewDoc: 'View document',
    },
    admin: {
      title: 'Admin',
      navHome: 'Dashboard',
      navOrders: 'Orders',
      navQuotes: 'Quotes',
      navInvoices: 'Invoices',
      navMessages: 'Messages',
      navLanguages: 'Languages',
      navServices: 'Services',
      navUsers: 'Users',
      navTranslators: 'Translators',
      navVerifiers: 'Verifiers',
      homeTitle: 'Administration',
      homeSubtitle: 'Manage orders, users and the translator network.',
      statOrders: 'Orders',
      statUsers: 'Users',
      statTranslators: 'Translators',
      statPending: 'Pending',
      statOverdue: 'Overdue',
      statDueSoon: 'Due < 48h',
      statPipeline: 'Pipeline',
      statInProgress: 'In progress',
      statReady: 'Ready',
      kpiQueueHint: 'To assign',
      kpiOverdueHint: 'Needs action now',
      kpiDueSoonHint: 'Within 48 hours',
      kpiUnpaid: 'Unpaid',
      pendingQueue: 'Assignment queue',
      urgentTitle: 'Urgent / priority',
      availableTranslators: 'Available translators',
      overdueTag: 'Overdue',
      dueSoonTag: 'Due soon',
      opsTitle: 'Operations hub',
      opsText: 'Filter by status/payment, set priority and assign with From→To matching.',
      recentOrders: 'Latest orders',
      ordersTitle: 'Orders',
      ordersSubtitle: 'Platform-wide tracking, filters and smart assignment.',
      colClient: 'Client',
      colTranslator: 'Translator',
      colTotal: 'Total',
      colPriority: 'Priority',
      colPayment: 'Payment',
      colStatus: 'Status',
      colCode: 'Code',
      searchOrders: 'Code, document, languages…',
      searchUsers: 'Name or email…',
      searchTranslators: 'Name, email, pairs…',
      filterAll: 'All',
      filterMatch: 'Compatible',
      filterPaymentAll: 'All payments',
      pickBest: 'Best match',
      willCreateMission: 'A mission will be created with the source document for translation.',
      assignNotes: 'Note for translator',
      assignNotesHint: 'Instructions, priority, expected format…',
      assignError: 'Could not assign. Try again.',
      cancel: 'Cancel',
      manageOrder: 'Advanced management',
      adminNotes: 'Internal notes',
      usersTitle: 'Users',
      usersSubtitle: 'Accounts registered on the platform.',
      colName: 'Name',
      colEmail: 'Email',
      colRole: 'Role',
      translatorsTitle: 'Translators',
      translatorsSubtitle: 'Translator network and availability.',
      colLangs: 'Languages',
      colMissions: 'Missions',
      assignTitle: 'Assign a translator',
      manageProfiles: 'Manage profiles',
      createTranslator: 'Create translator',
      password: 'Temporary password',
      quotesTitle: 'Quotes',
      quotesSubtitle: 'Create, price and send quotes to clients.',
      createQuote: 'Create quote',
      answerQuote: 'Price / send',
      sendQuote: 'Send to client',
      deadline: 'Deadline',
      serviceType: 'Type',
      message: 'Message',
      languagesTitle: 'Languages',
      languagesSubtitle: 'Offered language catalog.',
      addLanguage: 'Add language',
      importLanguages: 'Import languages (API)',
      importDone: 'Import completed',
      servicesTitle: 'Services',
      servicesSubtitle: 'Offered services catalog.',
      addService: 'Add service',
      serviceTitle: 'Title',
      serviceCategory: 'Category',
      catTranslation: 'Translation',
      catInterpreting: 'Interpreting',
      invoicesTitle: 'Invoices',
      invoicesSubtitle: 'Issue and track payments.',
      createInvoice: 'Create invoice',
      markPaid: 'Mark paid',
      messagesTitle: 'Messages',
      messagesSubtitle: 'Conversations with clients and professionals.',
      sendMessage: 'Send',
      thread: 'Thread',
      allThreads: 'All threads',
      recipient: 'Recipient',
      administration: 'Administration',
      activate: 'Activate',
      deactivate: 'Deactivate',
      delete: 'Delete',
      statDone: 'Completed',
      statRevenue: 'Revenue',
      statPendingPayments: 'Pending payments',
      statNewClients: 'New clients',
      statActivePros: 'Active translators & interpreters',
      hintNewClients: 'Last 30 days',
      hintInterpreters: 'interpreters',
      hintRevenue: 'Paid orders',
      hintPaymentsAmount: 'TND to collect',
      alertsTitle: 'Alerts & actions',
      alertUnassigned: 'Orders without an assignee',
      alertApplications: 'Applications to review',
      alertReviews: 'Documents awaiting verification',
      alertPayments: 'Pending payments',
      alertDueSoon: 'Orders nearing deadline',
      noAlerts: 'No alerts — all clear.',
      chartsTitle: 'Activity & breakdown',
      chartOrders: 'Orders by period',
      chartRevenue: 'Revenue by period',
      chartServices: 'Orders by service type',
      chartCategories: 'Translation / Interpreting',
      last6Months: 'Last 6 months',
      activityTitle: 'Recent activity',
      recentPayments: 'Latest payments',
      recentApplications: 'New applications',
      recentDocuments: 'New documents to process',
      pendingReviewsTitle: 'Pending verifications',
      colAmount: 'Amount',
      colDate: 'Date',
    },
    legal: {
      title: 'Verifier',
      navHome: 'Dashboard',
      navVerifications: 'My verifications',
      navProfile: 'My profile',
      homeTitle: 'Your verifications',
      homeSubtitle: 'Manage assigned legal and notary reviews.',
      statToReview: 'To review',
      statCorrections: 'Corrections',
      statValidated: 'Validated',
      statDueSoon: 'Due < 48h',
      statOverdue: 'Overdue',
      recentVerifications: 'Recent verifications',
      urgentVerifications: 'Urgent verifications',
      verificationsTitle: 'My verifications',
      verificationsSubtitle: 'All orders pending review.',
      colClient: 'Client',
      colDocument: 'Document',
      colLangs: 'Languages',
      colStatus: 'Status',
      colDeadline: 'Deadline',
      colType: 'Type',
      filterAll: 'All',
      filterPending: 'To review',
      filterCorrection: 'Corrections',
      filterValidated: 'Validated',
      detailTitle: 'Verification detail',
      detailSubtitle: 'Review documents and submit your decision.',
      originalDocs: 'Original documents',
      translatedDocs: 'Translations',
      checklist: 'Checklist',
      comments: 'Comments',
      addComment: 'Add a comment',
      requestCorrection: 'Request correction',
      validate: 'Validate',
      reject: 'Reject',
      correctionReason: 'Correction reason',
      rejectReason: 'Rejection reason',
      reasonRequired: 'A reason is required',
      profileTitle: 'Verifier profile',
      profileSubtitle: 'Professional information visible to the team.',
    },
  },
};

export const dashboardFr = shared.fr;
export const dashboardAr = shared.ar;
export const dashboardEn = shared.en;
